(function () {
    function initTradingInfo() {
        var copyButtons = document.querySelectorAll('.trading-info-copy-btn');

        copyButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                var value = button.getAttribute('data-copy-value');
                if (value) {
                    navigator.clipboard.writeText(value).then(function () {
                        button.classList.add('is-copied');
                        setTimeout(function () {
                            button.classList.remove('is-copied');
                        }, 2000);
                    }).catch(function (err) {
                        console.error('Failed to copy:', err);
                    });
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTradingInfo);
    } else {
        initTradingInfo();
    }
})();
